import { getRsvpAnswers } from "./rsvpAnswers.js";

export const RECORD_REGISTRATION_LABELS = {
  active: "Ativo",
  inactive: "Inativo",
};

export const RECORD_RSVP_LABELS = {
  yes: "Participação confirmada",
  no: "Não confirmou participação",
  unanswered: "Sem resposta",
  other: "Revisão necessária",
};

const isObject = (value) => value && typeof value === "object" && !Array.isArray(value);
const storedValueLabel = (value) => value === null || value === undefined ? "" : typeof value === "string" ? value : JSON.stringify(value);

export function participantRegistrationStatus(participant) {
  return Number(participant?.status) === 1 ? "active" : "inactive";
}

export function participantRsvpRecord(value, definition, isAttendance) {
  if (!definition) return { choice: "unavailable", status: "Nenhum RSVP configurado", answer: "—", channel: "—" };
  let document = value;
  let valid = true;
  if (value === null || value === undefined || value === "") document = { schema_version: 1, responses: {} };
  if (typeof document === "string") {
    try { document = JSON.parse(document); } catch (_) { valid = false; }
  }
  valid = valid && isObject(document) && document.schema_version === 1 && isObject(document.responses);
  const hasResponse = valid && Object.prototype.hasOwnProperty.call(document.responses, definition.definition_id);
  const response = hasResponse && isObject(document.responses[definition.definition_id]) ? document.responses[definition.definition_id] : null;
  const revision = Number(response?.revision ?? response?.response_revision);
  const validResponse = response && Object.prototype.hasOwnProperty.call(response, "choice")
    && ["yes", "no", null].includes(response.choice) && Number.isSafeInteger(revision) && revision >= 0;
  const choice = !valid || (hasResponse && (!validResponse || response.needs_review === true || response.valid === false))
    ? "other" : response?.choice || "unanswered";
  const optionId = response?.option_id || (["yes", "no"].includes(choice) ? choice : "");
  const answer = getRsvpAnswers(definition).find((option) => option.id === optionId);
  const origin = String(response?.origin_channel || response?.source || "");
  const channel = origin === "administrator" || origin === "panel_correction" ? "Administrador"
    : origin.startsWith("email") ? "E-mail" : origin.startsWith("whatsapp") ? "WhatsApp"
      : origin === "public_rsvp" ? "Página de confirmação" : "Não registrado";
  return {
    choice,
    status: !isAttendance && ["yes", "no"].includes(choice) ? "Respondido" : RECORD_RSVP_LABELS[choice],
    answer: choice === "unanswered" ? "—" : response?.answer_label || answer?.label || storedValueLabel(response?.value) || "—",
    channel: choice === "unanswered" ? "—" : channel,
    optionId,
    respondedAt: response?.accepted_at || response?.responded_at || null,
  };
}

export function participantRecordRows(participants, definition, isAttendance, checkinsAvailable, rsvpAvailable = true) {
  return participants.map((participant) => {
    const registration = participantRegistrationStatus(participant);
    const rsvp = rsvpAvailable ? participantRsvpRecord(participant.rsvp, definition, isAttendance)
      : { choice: "unavailable", status: "RSVP indisponível", answer: "—", channel: "—" };
    const hasCheckin = Boolean(participant.data_checkin) || Number(participant.has_checkin) === 1;
    return {
      ...participant,
      record_registration_choice: registration,
      record_registration_status: RECORD_REGISTRATION_LABELS[registration],
      record_rsvp_choice: rsvp.choice,
      record_rsvp_status: rsvp.status,
      record_rsvp_answer: rsvp.answer,
      record_rsvp_channel: rsvp.channel,
      record_rsvp_option_id: rsvp.optionId || "",
      record_rsvp_responded_at: rsvp.respondedAt,
      record_has_checkin: checkinsAvailable ? hasCheckin : null,
      record_checkin_status: checkinsAvailable ? hasCheckin ? "Com check-in" : "Sem check-in" : "Dados indisponíveis",
      record_checkin_count: checkinsAvailable ? (participant.checkinHistory || []).length : null,
    };
  });
}

export function filterParticipantRecords(participants, filter) {
  return participants.filter((participant) => (
    (!filter.registrationStatus || participant.record_registration_choice === filter.registrationStatus)
    && (!filter.rsvpChoice || participant.record_rsvp_choice === filter.rsvpChoice
      || (filter.rsvpChoice === "answered" && ["yes", "no"].includes(participant.record_rsvp_choice))
      || (filter.rsvpChoice.startsWith("answer:") && participant.record_rsvp_option_id === filter.rsvpChoice.slice(7)))
    && (!filter.checkinStatus || participant.record_has_checkin === (filter.checkinStatus === "with"))
  ));
}

export function participantRecordSummary(participants, checkinsAvailable) {
  const unique = [...new Map(participants.map((participant) => [String(participant.user_id), participant])).values()];
  const summary = { total: unique.length, active: 0, inactive: 0, yes: 0, no: 0, unanswered: 0, other: 0, checkedIn: checkinsAvailable ? 0 : null, entries: checkinsAvailable ? 0 : null, groups: {} };
  Object.keys(RECORD_RSVP_LABELS).forEach((choice) => { summary.groups[choice] = { total: 0, withCheckin: checkinsAvailable ? 0 : null, withoutCheckin: checkinsAvailable ? 0 : null }; });
  unique.forEach((participant) => {
    summary[participantRegistrationStatus(participant)] += 1;
    const group = summary.groups[participant.record_rsvp_choice];
    if (group) {
      summary[participant.record_rsvp_choice] += 1;
      group.total += 1;
      if (checkinsAvailable) group[participant.record_has_checkin ? "withCheckin" : "withoutCheckin"] += 1;
    }
    if (checkinsAvailable) {
      if (participant.record_has_checkin) summary.checkedIn += 1;
      summary.entries += participant.record_checkin_count || 0;
    }
  });
  return summary;
}
